export const FETCH_ACCOUNT_TYPES = 'FETCH_ACCOUNT_TYPES';
export const FETCH_ACCOUNT_TYPES_SUCCESS = 'FETCH_ACCOUNT_TYPES_SUCCESS';
export const FETCH_ACCOUNT_TYPES_ERROR = 'FETCH_ACCOUNT_TYPES_ERROR';

export const fetchAccountTypes = () => ({ type: FETCH_ACCOUNT_TYPES });
export const fetchAccountTypesSuccess = (payload: any) => ({ type: FETCH_ACCOUNT_TYPES_SUCCESS, payload });
export const fetchAccountTypesError = (payload: any) => ({ type: FETCH_ACCOUNT_TYPES_ERROR, payload });
